export default __webpack_public_path__ + "static/media/Ballroll_00040.b9441848.png";